import { AuthTokenFields } from '@lendi/core-constants';
export var Status;
(function (Status) {
    Status["Authenticating"] = "authenticating";
    Status["Authenticated"] = "authenticated";
    Status["Unauthenticated"] = "unauthenticated";
    Status["Unauthenticating"] = "unauthenticating";
    Status["Expired"] = "expired";
    Status["Errored"] = "errored";
})(Status || (Status = {}));
var ConnectionEnum;
(function (ConnectionEnum) {
    ConnectionEnum[ConnectionEnum["google-oauth2"] = 0] = "google-oauth2";
    ConnectionEnum[ConnectionEnum["paypal"] = 1] = "paypal";
    ConnectionEnum[ConnectionEnum["paypal-sandbox"] = 2] = "paypal-sandbox";
    ConnectionEnum[ConnectionEnum["salesforce"] = 3] = "salesforce";
    ConnectionEnum[ConnectionEnum["salesforce-sandbox"] = 4] = "salesforce-sandbox";
    ConnectionEnum[ConnectionEnum["sms"] = 5] = "sms";
    ConnectionEnum[ConnectionEnum["lendigroup-salesforce"] = 6] = "lendigroup-salesforce";
})(ConnectionEnum || (ConnectionEnum = {}));
export var PasswordlessAuthenticationStatus;
(function (PasswordlessAuthenticationStatus) {
    PasswordlessAuthenticationStatus["Errored"] = "errored";
    PasswordlessAuthenticationStatus["Sending"] = "sending";
    PasswordlessAuthenticationStatus["Sent"] = "sent";
    PasswordlessAuthenticationStatus["Verifying"] = "verifying";
    PasswordlessAuthenticationStatus["Verified"] = "verified";
    PasswordlessAuthenticationStatus["Denied"] = "denied";
})(PasswordlessAuthenticationStatus || (PasswordlessAuthenticationStatus = {}));
//# sourceMappingURL=types.js.map